import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useIsDevice } from '../../hooks/useIsDevice';
import { settingsTabs } from '../../lib/constants.tsx';
import { renderTabContent } from '../../utils/settings';
import { ArrowLeft } from 'iconoir-react';

const SettingsPage = () => {
  const { isMobile } = useIsDevice();
  const [searchParams] = useSearchParams();

  // BUG-008 FIX: Honor ?tab= URL parameter for deep linking
  const getInitialTab = () => {
    const tabParam = searchParams.get('tab');
    if (tabParam && settingsTabs.some(t => t.value === tabParam)) {
      return tabParam;
    }
    return isMobile ? '' : settingsTabs[0].value;
  };

  const [activeTab, setActiveTab] = useState(getInitialTab);

  // Update active tab when URL changes (e.g., from profile page links)
  useEffect(() => {
    const tabParam = searchParams.get('tab');
    if (tabParam && settingsTabs.some(t => t.value === tabParam)) {
      setActiveTab(tabParam);
    }
  }, [searchParams]);

  const handleTabClick = (tab: string) => {
    setActiveTab(tab);
  };

  return (
    <div className='px-4 md:px-8 py-8 md:py-12'>
      <div className='mb-8 md:mb-12'>
        <h3 className='!font-medium text-heading-500 !mb-1'>Settings</h3>
        <p className='mb-0 text-sm text-body-400'>
          Manage your profile, AI preferences, security, and account settings.
        </p>
      </div>

      <div className='lg:flex gap-6'>
        <div
          className={`lg:w-[17.625rem] lg:min-w-[17.625rem] max-h-[31.25rem] border border-purple-25 bg-gray-light-50 rounded-xl px-4 py-4 lg:py-6 lg:mb-0 mb-6 ${isMobile ? (activeTab === '' ? '' : 'hidden') : ''}`}
        >
          <div className='lg:space-y-2 block gap-2 overflow-x-auto scrollbar-hide'>
            {/* Buttons, not clickable divs: all five settings sections were
                unreachable by keyboard and announced as plain text. */}
            {settingsTabs.map(tab => (
              <button
                type='button'
                role='tab'
                aria-selected={activeTab === tab.value}
                key={tab.value}
                className={`w-full text-left py-3 px-5 min-w-fit rounded-xl flex items-center gap-2 cursor-pointer transition-all duration-200 font-medium text-body-400 ${activeTab === tab.value ? 'bg-theme-blue-50 text-body-500' : ''}`}
                onClick={() => handleTabClick(tab.value)}
              >
                {tab.icon}
                <span className='whitespace-nowrap'>{tab.label}</span>
              </button>
            ))}
          </div>
        </div>
        <div className='grow'>
          {isMobile && activeTab !== '' && (
            <div className='lg:hidden flex items-center gap-3 mb-6 bg-gray-light-100 rounded-xl p-4'>
              <ArrowLeft
                className='w-6 h-6 text-body-500'
                onClick={() => setActiveTab('')}
              />
              <p className='!font-medium text-[1.125rem] mb-0'>
                {settingsTabs.find(tab => tab.value === activeTab)?.label}
              </p>
            </div>
          )}
          {renderTabContent(activeTab)}
        </div>
      </div>
    </div>
  );
};

export default SettingsPage;
